import { useEffect, useRef, useState } from "react";
import { onSaved } from "@/lib/saved-indicator";

const SAVED_VISIBLE_MS = 2000;

// Subscribes to the global saved-event bus (Task #2874). On each successful
// mutation it flips `visible` to true and (re)schedules a timer to hide it
// ~2s later. Re-arming the timer on every notification keeps the chip on
// screen while saves are still landing rather than disappearing mid-burst.
export function useSavedIndicator(): boolean {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const unsubscribe = onSaved(() => {
      setVisible(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setVisible(false);
        timerRef.current = null;
      }, SAVED_VISIBLE_MS);
    });
    return () => {
      unsubscribe();
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return visible;
}
